import React, { useContext, useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'
import cl from './Add.module.css'
import Plus from "../../../../assets/Icon/Plus";
import Mobile from "../../../../assets/Icon/Mobile";
import At from "../../../../assets/Icon/At";
import Id from "../../../../assets/Icon/Id";
import User from "../../../../assets/Icon/User";
import Dealer from "../../../../assets/Icon/Client";
import { AppContext } from '../../../../providers/appProvider';
import Select from "react-select";
import { selectStyle } from './selectStyle';
import { useAuth } from '../../../../providers/authProvider';

const Add = ({ dealerService }) => {
    const auth = useAuth(); 

    const dealerResetData = {
        id: 0,
        firstname: "",
        lastname: "",
        personal: "",
        email: "",
        mobile: "",
        saler_id: 0,
    }
 
    const stylesError = {
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            boxShadow: state.isFocused ? 'none' : 'none',
            '&:hover': {
                border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)', // Apply blue border on hover if focused, otherwise regular border
            },
            minHeight: "35px",
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
        }),

    };

 
    const { appState, app } = useContext(AppContext);
    const salers = appState.salers.map((seler) => ({ value: seler.id, label: `${seler.firstname} ${seler.lastname}` }));

    const [newDealer, setNewDealer] = useState(dealerResetData)
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})

    const validateDealer = (dealer) => {
        const messages = {};

        if (dealer.firstname.length < 2) {
            messages.firstname = { message: 'მიუთითეთ სახელი', isValid: false };
        }

        if (dealer.lastname.length < 2) {
            messages.lastname = { message: 'მიუთითეთ გვარი', isValid: false };
        }

        if (dealer.personal.length != 11) {
            messages.personal = { message: 'საჭროა 11 სიმბოლო', isValid: false };
        }

        if (dealer.mobile.length != 9) {
            messages.mobile = { message: 'საჭროა 9 სიმბოლო', isValid: false };
        }

        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!dealer.email || dealer.email.length === 0 || !emailRegex.test(dealer.email)) {
            messages.email = { message: 'ელ-ფოსტა არასწორია', isValid: false };
        }
         
        if (dealer.saler_id < 1  && auth.session.isAdmin) {
            messages.saler_id = { message: 'სავალდებულოა', isValid: false };
        }

  
        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;
    };

    const reValidate = () => {
        const isValidate = validateDealer(newDealer)

    }

    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateDealer(newDealer)
        }
    }, [newDealer, isFirstValidated]);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const saveHandle = () => {

        const isValidate = validateDealer(newDealer)

        if (isValidate === true) {
            dealerService.add(newDealer)
            setIsModalOpen(false)
        } else {
            setIsFirstValidated(true)
        }

    };

    const handleDealerChange = async (event) => {
        let val = event.target.value;
        setNewDealer(prevDealer => ({
            ...prevDealer,
            [event.target.name]: val
        }));
    };

    const openAdd = () => {
        setValidates({})
        setIsModalOpen(true)
        setIsFirstValidated(false)
        setNewDealer(dealerResetData)
    }

    return (
        <div>

            <span onClick={() => openAdd()} className={cl.AddBtn}>
                <span className={cl.icon} > <Plus /></span>
                დილერის დამატება
            </span>

            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

                <div className={cl.modalHead} >
                    <h3>
                        <span className={cl.iconHead} > <Plus /></span> დამატება
                    </h3>
                </div>
              
                <div className={cl.inp2col}>

                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS"
                                className={validates && validates.firstname ? cl.input + ' ' + cl.errorInput : cl.input}
                                placeholder="სახელი" name="firstname" value={newDealer.firstname} onChange={handleDealerChange} autoComplete="off" />
                            <div className={cl.crmIcon}>
                                <User />
                            </div>
                        </div>
                    </div>

                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS"
                                className={validates && validates.lastname ? cl.input + ' ' + cl.errorInput : cl.input}
                                placeholder="გვარი" name="lastname" value={newDealer.lastname} onChange={handleDealerChange} autoComplete="off" />
                            <div className={cl.crmIcon}>
                                <User />
                            </div>
                        </div>
                    </div>

                </div>

                <div className={cl.groupInput}>
                    <div className={cl.groupInputIcon}>
                        <input type="textS"
                            className={validates && validates.personal ? cl.input + ' ' + cl.errorInput : cl.input}
                            placeholder="პირადი ნომერი" name="personal" value={newDealer.personal} onChange={handleDealerChange} autoComplete="off" />
                        <div className={cl.crmIcon}>
                            <Id />
                        </div>
                    </div>
                    {validates && validates.personal &&
                        <div className={cl.errorMsg} >{validates.personal.message}</div>}
                </div>


                <div className={cl.inp2col} style={{ marginBottom: 0 }}>
                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS"
                                className={validates && validates.mobile ? cl.input + ' ' + cl.errorInput : cl.input}
                                placeholder="მობილური" name="mobile" value={newDealer.mobile} onChange={handleDealerChange} autoComplete="off" />
                            <div className={cl.crmIcon}><Mobile /></div>
                        </div>
                        {validates && validates.mobile &&
                            <div className={cl.errorMsg} >{validates.mobile.message}</div>}

                    </div>

                    <div className={cl.groupInput}>
                        <div className={cl.groupInputIcon}>
                            <input type="textS"
                                className={validates && validates.email ? cl.input + ' ' + cl.errorInput : cl.input}
                                placeholder="ელ-ფოსტა" name="email" value={newDealer.email} onChange={handleDealerChange} autoComplete="off" />
                            <div className={cl.crmIcon}><At /></div>
                        </div>
                        {validates && validates.email &&
                            <div className={cl.errorMsg} >{validates.email.message}</div>}

                    </div>

                </div>


                {auth.session.isAdmin &&  
                <div>  
                   
                    <Select
                        styles={validates && validates.saler_id ? { ...selectStyle, ...stylesError } : selectStyle} 
                        options={salers}
                        placeholder="აირჩიე სელერი"
                        value={salers.find(option => option.value === newDealer.saler_id)}
                        onChange={(selectedOption) => {
                            setNewDealer(prevState => ({
                                ...prevState,
                                saler_id: selectedOption ? selectedOption.value : 0,
                            }));
                        }}
                    />
                </div>
                }

                <span onClick={saveHandle} className={cl.btnPrimary}>დამატება</span>
            </Modal>
        </div>
    );
};

export default Add;